import { Component, Input, Renderer2, ElementRef, HostBinding } from '@angular/core';
export class TdDataTableCellComponent {
/**
 * numeric?: boolean
 * Makes cell follow the numeric data-table specs.
 * Defaults to 'false'
 */
numeric: boolean = false;
/**
 * @return {?}
 */
get bindNumeric(): boolean {
    return this.numeric;
  }
/**
 * @param {?} _elementRef
 * @param {?} _renderer
 */
constructor(private _elementRef: ElementRef,
private _renderer: Renderer2) {
    this._renderer.addClass(this._elementRef.nativeElement, 'td-data-table-cell');
  }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  moduleId: module.id,
  /* tslint:disable-next-line */
  selector: 'td[td-data-table-cell]',
  styleUrls: ['./data-table-cell.component.css' ],
  templateUrl: './data-table-cell.component.html',
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: Renderer2, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'numeric': [{ type: Input, args: ['numeric', ] },],
'bindNumeric': [{ type: HostBinding, args: ['class.mat-numeric', ] },],
};
}

function TdDataTableCellComponent_tsickle_Closure_declarations() {
/** @type {?} */
TdDataTableCellComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TdDataTableCellComponent.ctorParameters;
/** @type {?} */
TdDataTableCellComponent.propDecorators;
/**
 * numeric?: boolean
 * Makes cell follow the numeric data-table specs.
 * Defaults to 'false'
 * @type {?}
 */
TdDataTableCellComponent.prototype.numeric;
/** @type {?} */
TdDataTableCellComponent.prototype._elementRef;
/** @type {?} */
TdDataTableCellComponent.prototype._renderer;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
